// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerVouchersApplyApi } from "../../services/Api/CustomerVoucherApplyApi"
import { getCustomerVouchersApplyList,getErrors } from "../reducers/CustomerVouchersApplyReducer"
 

// Watchers
function* customerVouchersApplySaga() {
	yield takeEvery("customerVouchersApply/getCustomerVouchersApply", getCustomerVouchers)
}

// Sagas
function* getCustomerVouchers(action) {
	// console.log(action)
	try {
		const getCustomerVouchersApply = yield call(getCustomerVouchersApplyApi, action.payload)
		// console.log(getCustomerVouchersApply.status);
		if (getCustomerVouchersApply.request.status === 200) {
			yield put(getCustomerVouchersApplyList(getCustomerVouchersApply))
			// console.log(getCustomerVouchersApply.status);
		} else {
			yield put(getErrors(getCustomerVouchersApply))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerVouchersApplySaga)])
}
